import { render, staticRenderFns } from "./BoxCreateEdit.vue?vue&type=template&id=777f64cb&scoped=true"
import script from "./BoxCreateEdit.vue?vue&type=script&lang=js"
export * from "./BoxCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./BoxCreateEdit.vue?vue&type=style&index=0&id=777f64cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f64cb",
  null
  
)

export default component.exports